import React from "react";
import {connect} from "react-redux";
import {State} from "../reducers";
import {Icon} from "@vitalsource/vstui";
import {Button} from "@vitalsource/vstui";
import FileImportProgressIndicator from "../components/progressIndicator/FileImportProgressIndicator";
import {GenericThunkDispatch} from "../types/Types";
import {importFileResetProcess} from "../actions/products";

export interface OwnProps {
  children: React.ReactNode;
  handleClose: () => void;
  handleUploadRetry: () => void;
}

const mapStateToProps = (state: State, ownProps: OwnProps) => ({
  progressInfo: state.products.fileImport,
  error: state.error["IMPORT_FILE"],
  ...ownProps
});

const mapDispatchToProps = (dispatch: GenericThunkDispatch) => {
  return {
    resetImportProcess: () => {
      dispatch(importFileResetProcess());
    }
  }
};


export default connect(mapStateToProps, mapDispatchToProps)(FileImportProgressIndicator);
